import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import { Pagination } from '@/components/Pagination';
import request from '@/utils/request';
import { officialList } from '@/api';
import { mapMutations, mapState } from 'vuex';
export default {
  components: {
    Pagination: Pagination
  },
  data: function data() {
    return {
      questionList: [],
      total: null,
      pageNum: 1,
      pageSize: 10
    };
  },
  watch: {
    searchValue: function searchValue() {
      this.handleSearch();
    }
  },
  computed: _objectSpread({}, mapState(['searchValue'])),
  methods: {
    currentChange: function currentChange(pageNo) {
      this.pageNum = pageNo;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res, regExp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loaded = true;
              params = {
                pageNum: _this.pageNum,
                pageSize: _this.pageSize,
                catCodes: 'meet_professor',
                title: _this.searchValue
              };
              _context.next = 4;
              return request.get(officialList, {
                params: params
              });
            case 4:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _this.questionList = res.obj.rows || [];
              _this.total = res.obj.total || 0;
              if (_this.questionList.length) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              regExp = new RegExp(_this.searchValue, 'g');
              _this.questionList.map(function (item) {
                item.title = item.title.replace(regExp, "<span style=\"color: #21ADB9;\">".concat(_this.searchValue, "</span>"));
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    this.handleSearch();
  }
};